module.exports = __webpack_public_path__ + "static/media/Vk.7acae411.svg";